/* SearchOverlay.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _15 = "._t9eczr6s{transform:translateX(-50%)}";
const _14 = "._1ltv1ssb{left:50%}";
const _13 = "._154i1fqw{top:7.5rem}";
const _12 = "._kqswstnw{position:absolute}";
const _11 = "._1bsb1c3h{width:50pc}";
const _10 = "._1e0c1ule{display:block}";
const _9 = "._18s8mgjw{margin:var(--ds-space-negative-200,-1pc)}";
const _8 = "._2rko1j6v{border-radius:1rem}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import { SearchOverlayEnterKeyEvent, SearchOverlaySuggestionClickEvent, SearchOverlayViewEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { breakpointValues, useResponsiveBreakpoint } from '@atlassian/mpac-primitives';
import React from 'react';
import { ANALYTICS_ACTION_SUBJECT_ID } from '../constants';
import { SearchDropdownOverlay } from '../SearchDropdown';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _7 = "._1pbyjbo9{z-index:100000}";
const _6 = "._4t3i1osq{height:100%}";
const _5 = "._1bsb1osq{width:100%}";
const _4 = "._1ltvidpf{left:0}";
const _3 = "._154iidpf{top:0}";
const _2 = "._kqsw1n9t{position:fixed}";
const _ = "._11q7vuon{background:var(--ds-surface,#fff)}";
const FullWidthSearchDropdown = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_11q7vuon _kqsw1n9t _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _1pbyjbo9", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  FullWidthSearchDropdown.displayName = 'FullWidthSearchDropdown';
}
const Overlay = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _8, _9, _10, _11, _12, _13, _14, _15]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_11q7vuon _2rko1j6v _18s8mgjw _1e0c1ule _1bsb1c3h _kqswstnw _154i1fqw _1ltv1ssb _t9eczr6s", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Overlay.displayName = 'Overlay';
}
export function SearchOverlay(_ref3) {
  let {
    onClose,
    analytics
  } = _ref3;
  const {
    value: screenSize
  } = useResponsiveBreakpoint();
  const fireAnalyticsEvent = useAnalyticsEvents();
  const handleViewedAnalytics = _ref4 => {
    let {
      query,
      suggestionSource,
      count
    } = _ref4;
    fireAnalyticsEvent({
      eventType: SearchOverlayViewEvent,
      actionSubjectId: ANALYTICS_ACTION_SUBJECT_ID.SEARCH_OVERLAY_VIEW,
      source: analytics.source,
      attributes: {
        query,
        suggestionSource,
        count
      }
    });
  };
  const handleSearchItemSelectionAnalytics = _ref5 => {
    let {
      query,
      position,
      popularity,
      suggestionSource,
      count
    } = _ref5;
    fireAnalyticsEvent({
      eventType: SearchOverlaySuggestionClickEvent,
      actionSubjectId: ANALYTICS_ACTION_SUBJECT_ID.SEARCH_OVERLAY_ITEM_SELECTED,
      source: analytics.source,
      attributes: {
        query,
        position,
        popularity,
        suggestionSource,
        count
      }
    });
  };
  const handleEnterKeyPressAnalytics = _ref6 => {
    let {
      query,
      suggestionSource,
      count
    } = _ref6;
    fireAnalyticsEvent({
      eventType: SearchOverlayEnterKeyEvent,
      actionSubjectId: ANALYTICS_ACTION_SUBJECT_ID.SEARCH_OVERLAY_ENTER_KEY_PRESSED,
      source: analytics.source,
      attributes: {
        query,
        position: -1,
        suggestionSource,
        count
      }
    });
  };
  const searchInput = /*#__PURE__*/_jsx(SearchDropdownOverlay, {
    onViewed: handleViewedAnalytics,
    closeOverlay: onClose,
    onSuggestionSelection: handleSearchItemSelectionAnalytics,
    onEnterKeyPress: handleEnterKeyPressAnalytics
  });
  if (screenSize <= breakpointValues.sm) {
    return /*#__PURE__*/_jsx(FullWidthSearchDropdown, {
      children: searchInput
    });
  }
  return /*#__PURE__*/_jsx(ModalTransition, {
    children: /*#__PURE__*/_jsx(Modal, {
      label: "Search input",
      onClose: onClose,
      children: /*#__PURE__*/_jsx(Overlay, {
        children: searchInput
      })
    })
  });
}